import type { OrganizationMember } from "@/model/app/organization-member"
import { $date } from "@/vf"
import { h } from "vue"
import { useI18n } from "vue-i18n"

export function renderConnectionStatus(member: OrganizationMember, t: ReturnType<typeof useI18n>["t"]) {
    const r = []
    if (member.invitationExpiryDate) {
        r.push(
            h(
                "div",
                {
                    class: "mb-1",
                },
                [
                    h("i", {
                        class: "fas fa-fw fa-envelope mr-1",
                    }),
                    t("@app:my_athletes.invitation_expires_at", {
                        date: $date(member.invitationExpiryDate),
                    }),
                ],
            ),
        )
    }
    if (member.managerStatus === "invitation_expired" || member.connectionStatus === "invitation_expired") {
        r.push(
            h(
                "div",
                {
                    class: "mb-1",
                },
                [
                    h("i", {
                        class: "fa far fas-sm fa-fw fa-circle management-status-invitation-expired",
                    }),
                    t("@app:ManagementStatus.invitation_expired"),
                ],
            ),
        )
    }
    if (member.connectionStatus === "declined") {
        r.push(
            h(
                "div",
                {
                    class: "mb-1",
                },
                [
                    h("i", {
                        class: "fa far fas-sm fa-fw fa-circle management-status-declined",
                        title: t("@app:ManagementStatus.declined"),
                    }),
                    t("@app:ManagementStatus.declined"),
                ],
            ),
        )
    }

    if (member.managerStatus === "declined") {
        r.push(
            h(
                "div",
                {
                    class: "mb-1",
                },
                [
                    h("i", {
                        class: "fa far fas-sm fa-fw fa-circle management-status-declined",
                        title: t("@app:ManagementStatus.declined"),
                    }),
                    t("@app:ManagementStatus.declined"),
                ],
            ),
        )
    }

    if (member.managerUserId) {
        r.push(
            renderConnectionStatusItem(
                member.managerStatus,
                t("@app:ManagementStatus." + member.managerStatus),
                member.managerUserId,
                member.managerUser?.firstName,
                member.managerUser?.lastName,
                t("@app:organization_member.managementTypes.manager"),
            ),
        )
    }
    if (member.connectionUserId) {
        r.push(
            renderConnectionStatusItem(
                member.connectionStatus,
                t("@app:ManagementStatus." + member.connectionStatus),
                member.connectionUserId,
                member.connectedUser?.firstName,
                member.connectedUser?.lastName,
                t("@app:organization_member.managementTypes.myself"),
            ),
        )
    }

    const orgaName =
        member.organizationName ??
        (member.organization && member.organization.type === "Organization"
            ? member.organization.name
            : t("@app:organization_member.organization.not_associated"))

    r.push(
        h(
            "div",
            {
                class: "mb-1",
            },
            [
                h("i", {
                    class: "fa fa-fw fa-building-user text-primary text-sm-dark",
                }),
                " " + orgaName,
            ],
        ),
    )

    return r
}

function renderConnectionStatusItem(
    status: string | undefined,
    statusTitle: string,
    userId: string,
    firstName: string,
    lastName: string,
    label: string,
) {
    return h(
        "div",
        {
            class: "mb-1",
        },
        [
            h("i", {
                class: "fa far fas-sm fa-fw fa-circle management-status-" + status,
                title: statusTitle,
            }),
            label + ": " + userId + (firstName || lastName ? " (" + [firstName, lastName].join(" ") + ")" : ""),
        ],
    )
}
